// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useAutoUpdatingRef } from '../../hooks/useAutoUpdatingRef'
import { useDispatch, useSelector } from 'react-redux'
import './CalendarPage.scss'
import { CalendarComponent, PageLoadingSpinner } from 'ui_kit_qmd'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import moment from 'moment-timezone'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { v4 as uuidv4 } from 'uuid'
import { allTimezones, useTimezoneSelect } from 'react-timezone-select'
import DetailsView from './DetailsView/DetailsView'
import {
  AVAILABILITY_LABEL,
  AVAILABILITY_ROUTE,
  CALENDAR_PAGE_DELETE_EVENT_CONFIRMATION_POP_UP_BODY_TEXT,
  CALENDAR_PAGE_DELETE_EVENT_CONFIRMATION_POP_UP_PRIMARY_BUTTON_TEXT,
  CALENDAR_PAGE_DELETE_EVENT_CONFIRMATION_POP_UP_SECONDARY_BUTTON_TEXT,
  CALENDAR_PAGE_DELETE_EVENT_CONFIRMATION_POP_UP_TITLE,
  LOCAL_STORAGE_STATE_TO_CALENDAR,
  NEW_VISIT_ROUTE,
} from '../../utils/constants'
import { CalendarPageListener } from './CalendarPageListener'
import {
  addToSchedule,
  cancelVisit,
  deleteEvent,
  editSchedule,
  getAppointmentInfo,
  getCurrentSchedule,
  getScheduleInfo,
  getVisitTypeGroups,
} from '../../store/calendar/CalendarThunk'
import {
  resetScheduleInfoRecurring,
  setCalendarOffsetBeforeNewVisit,
  setCalendarRangeBeforeNewVisit,
  setError,
  setIsAppointmentPopUpInfoVisible,
  setIsDeleteCalendarEventSuccess,
  setIsSuccessScheduleEdit,
} from '../../store/calendar/CalendarActions'
import FullTextPositionToolTip from '../../components/FullTextPositionToolTip/FullTextPositionToolTip'
import { isEllipsisActive } from '../../utils/commonMembersPage'
import SelectModePopUp from './SelectModePopUp/SelectModePopUp'
import AvailabilityPopUp from './AvailabilityPopUp/AvailabilityPopUp'
import TimeZoneSelect from '../../components/time-zone-select/timeZoneSelect'
import { ConfirmationPopup } from '../../components/confirmation-popup/confirmationpopup'
import { styles, text } from './Constants'
import ScheduleDetailView from './components/schedule-detail-view/ScheduleDetailView'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { getMember } from '../../store/member/MemberThunk'
import { getTimeZones } from '../../utils/common'
import { CancelVisitPopup } from '../../components/CancelVisitPopup/CancelVisitPopup'
import { isAsynchronousVisitMethod } from '../../utils/getVisitTypeLabel'
import { getValueOfNewSearchParamsByFieldName, isValidDate } from '../Availability/tools'
import {
  DATE_TIME_ISO_FORMAT,
  DEFAULT_DATE_VALUE_FORMAT,
  TIME_FOR_DATE_RANGE_REQUEST_FROM,
  TIME_FOR_DATE_RANGE_REQUEST_TO,
} from '../../utils/dateUtils'
import { setInitialTimeZone } from '../../store/timeZone/timeZoneActions'
import { replaceTimezone } from './helper'
import { buildEditRecurringSchedulePayload } from './buildEditRecurringSchedulePayload'
import Portal from '../../components/portal/Portal'

// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
const CalendarPageContainerStyle = {
  overflowY: 'hidden',
  overflowX: 'hidden',
  minWidth: 1200,
}
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
const CalendarPageSidePanelStyle = {
  zIndex: 2,
}

// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
const adminPageContainerStyle = { position: 'inherit' }
const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
const CalendarPage = memo(({ crumbsLabel, useAdminWrapper = true }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const timezones = getTimeZones(allTimezones)
  const location = useLocation()
  const { parseTimezone } = useTimezoneSelect({ timezones, labelStyle: 'abbrOnly' })
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const loading = useSelector((state) => state.calendarPageReducer.loading)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const memberLoading = useSelector((state) => state.member.loading)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const scheduleStore = useSelector((state) => state.calendarPageReducer.schedule)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const pnbScheduleStore = useSelector((state) => state.calendarPageReducer.pnbSchedule)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const visitsScheduleStore = useSelector((state) => state.calendarPageReducer.visitsSchedule)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const visitTypeGroups = useSelector((state) => state.calendarPageReducer.visitTypeGroups)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const error = useSelector((state) => state.calendarPageReducer.error)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const memberError = useSelector((state) => state.member.error)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const isAppointmentPopUpInfoVisible = useSelector((state) => state.calendarPageReducer.isAppointmentPopUpInfoVisible)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const scheduleInfoFrom = useSelector((state) => state.calendarPageReducer.scheduleInfoFrom)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const recurringBaseTimeZone = useSelector((state) => state.calendarPageReducer.recurringBaseTimeZone)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const scheduleInfoTo = useSelector((state) => state.calendarPageReducer.scheduleInfoTo)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const addToScheduleSuccess = useSelector((state) => state.calendarPageReducer.addToScheduleSuccess)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const editScheduleSuccess = useSelector((state) => state.calendarPageReducer.editScheduleSuccess)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const timeZoneFromTheStore = useSelector((state) => state.timeZoneReducer.initialTimeZone)

  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const deleteCalendarEventSuccess = useSelector((state) => state.calendarPageReducer.deleteCalendarEventSuccess)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const calendarRangeBeforeNewVisit = useSelector((state) => state.calendarPageReducer.calendarRangeBeforeNewVisit)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const calendarOffsetBeforeNewVisit = useSelector((state) => state.calendarPageReducer.calendarOffsetBeforeNewVisit)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const AppointmentInfo = useSelector((state) => state.calendarPageReducer.AppointmentInfo)
  const [showAvailabilityView, setShowAvailabilityView] = useState(false)
  const [showEditPopUpView, setShowEditPopUpView] = useState(null)
  const [showPNBView, setShowPNBView] = useState(false)
  const [clickedStartDateTime, setClickedStartDateTime] = useState({})
  const [clickedEndDateTime, setClickedEndDateTime] = useState({})
  const [showDetails, setShowDetails] = useState(false)
  const [detailsInfo, setDetailsInfo] = useState({})
  const [isShowSelectRecursionChangeModePopUp, setIsShowSelectRecursionChangeModePopUp] = useState(false)
  const [isSelectModePopUp, setIsSelectModePopUp] = useState(false)
  const [isRecurrenceOn, toggleIsRecurrenceOn] = useState(false)
  const [appointmentNameToolTipInfo, setAppointmentNameToolTipInfo] = useState(null)
  const [selectedAppointment, setSelectedAppointment] = useState('')
  const [deleteEventConfirmationPopUp, setDeleteEventConfirmationPopUp] = useState(null)
  const [isInitialDateRangeRendering, setIsInitialDateRangeRendering] = useState(true)
  const [deleteRecurringEventConfirmationPopUp, setDeleteRecurringEventConfirmationPopUp] = useState(false)
  const [showCancelSelectedVisit, setShowCancelSelectedVisit] = useState(false)
  const [availableStatesCodesArray, setAvailableStatesCodesArray] = useState([])
  const [parsedTimeZone, setParsedTimeZone] = useState('')
  const [forceShowActiveCalendarDate, setForceShowActiveCalendarDate] = useState(false)
  const [forceSetCalendarRangeConfig, setForceSetCalendarRangeConfig] = useState(null)
  const daysOfWeekRef = useRef(null)
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const sideBarRef = useRef(null)
  const startDateTimeChange = useRef(false)
  const endDateTimeChange = useRef(false)
  const { queryId } = useParams()
  const { state: locationState } = useLocation()
  const [memberState, setMemberState] = useState(null)
  const [searchParams, setSearchParams] = useSearchParams()
  const searchParamsRef = useAutoUpdatingRef(searchParams)
  const setSearchParamsRef = useAutoUpdatingRef(setSearchParams)
  const { from } = Object.fromEntries(searchParams)
  // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
  const state = (locationState ?? JSON.parse(localStorage.getItem(LOCAL_STORAGE_STATE_TO_CALENDAR))) || memberState
  const stateRef = useAutoUpdatingRef(state)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const member = useSelector((storeState) => storeState.member?.members[state?.providerId ?? queryId])
  const providerAvailableStates = useMemo(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    () => [...new Set(member?.Licenses?.map((license) => license.StateCode))],
    [member?.Licenses],
  )
  const [customTimeZone, setCustomTimeZone] = useState(timeZoneFromTheStore)
  useEffect(() => {
    if (!locationState && member) {
      const { Prefix, FirstName, LastName, Suffix, ImageUrl, memberId } = member
      setMemberState({
        // @ts-expect-error TS2353 -- MIGRATION: not approved, fix when encountered
        ImageUrl,
        providerId: memberId,
        providerName: `${Prefix || ''} ${FirstName} ${LastName} ${Suffix || ''}`,
        timezone: currentTimeZone,
        customTimeZone: currentTimeZone,
        search: '',
      })
    } else if (locationState) {
      setMemberState(null)
    }
  }, [member])

  useEffect(() => {
    if (memberError === getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'Provider')) {
      navigate(state?.location || AVAILABILITY_ROUTE)
    }
  }, [memberError, navigate, state?.location])

  const [localSchedule, setLocalSchedule] = useState([])
  const [localPnbSchedule, setLocalPnbSchedule] = useState([])
  const [localVisitsSchedule, setLocalVisitsSchedule] = useState([])
  const [calendarEndpoints, setCalendarEndpoints] = useState()
  const lastScheduleArgsRef = useRef(null)
  const [localVisitTypeGroups, setLocalVisitTypeGroups] = useState([])

  const onCloseDeleteEventConfirmationPopUp = useCallback(() => {
    setDeleteEventConfirmationPopUp(null)
  }, [])
  const onCloseDeleteRecurringEventConfirmationPopUp = useCallback(() => {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setDeleteRecurringEventConfirmationPopUp(null)
  }, [])

  useEffect(() => {
    setLocalSchedule(scheduleStore?.[state?.providerId])
    setLocalPnbSchedule(pnbScheduleStore?.[state?.providerId])
    setLocalVisitsSchedule(visitsScheduleStore?.[state?.providerId])
    setLocalVisitTypeGroups(visitTypeGroups?.[state?.providerId] || [])
  }, [scheduleStore, visitsScheduleStore, pnbScheduleStore, state?.providerId, visitTypeGroups])

  useEffect(() => {
    const initialTz = timeZoneFromTheStore || state?.timezone
    setCustomTimeZone(initialTz)
    if (parseTimezone && initialTz) {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      setParsedTimeZone(parseTimezone(initialTz)?.label)
    }
    // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
    dispatch(getMember(state?.providerId ?? queryId, 'Provider'))
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    dispatch(getVisitTypeGroups(state?.providerId))
    if ((!state?.providerId || !state?.providerName) && !queryId) {
      navigate(state?.location || AVAILABILITY_ROUTE)
    }

    return () => {
      dispatch(setError(''))
    }
  }, [])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const mouseOverHandler = useCallback((e, title, type) => {
    const toolTipContainerPositionStyle = {
      left: window.innerWidth - e.clientX < 500 ? e.clientX - 640 : e.clientX - 220,
      top: e.clientY > 250 ? e.clientY - 100 : e.clientY + 15,
      maxWidth: window.innerWidth - e.clientX < 600 ? 'none' : 450,
      zIndex: 1000000000,
      title,
    }
    switch (type) {
      case 'providerName':
        if (isEllipsisActive(document.getElementById(`calendarHeaderProviderName`))) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          setAppointmentNameToolTipInfo(toolTipContainerPositionStyle)
        }
        break
      default:
        break
    }
  }, [])
  const mouseOutHandler = useCallback(() => {
    setAppointmentNameToolTipInfo(null)
  }, [])

  useEffect(() => {
    if (error && (showCancelSelectedVisit || deleteEventConfirmationPopUp || deleteRecurringEventConfirmationPopUp)) {
      setShowCancelSelectedVisit(false)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setDeleteRecurringEventConfirmationPopUp(null)
      setDeleteEventConfirmationPopUp(null)
    }
  }, [error])

  useEffect(() => {
    if (state?.openCalendarDetails) {
      getAppointmentInfoById(state?.visitId)
      localStorage.setItem(LOCAL_STORAGE_STATE_TO_CALENDAR, JSON.stringify({ ...state, openCalendarDetails: false }))
    }
  }, [])

  useEffect(() => {
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    if (showEditPopUpView?.isRecursive) {
      setIsShowSelectRecursionChangeModePopUp(true)
    } else {
      setIsShowSelectRecursionChangeModePopUp(false)
    }
  }, [showEditPopUpView])

  const setStartDateHandler = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (isRecursiveEvent, isRecursionOn, newStartOrEndDateObj, type) => {
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      const firstStartTime = showEditPopUpView.OccurrenceStartTime
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      const firstEndTime = showEditPopUpView.OccurrenceEndTime

      if (type === 'startTime') {
        startDateTimeChange.current = !(JSON.stringify(firstStartTime) === JSON.stringify(newStartOrEndDateObj))
      } else {
        endDateTimeChange.current = !(JSON.stringify(firstEndTime) === JSON.stringify(newStartOrEndDateObj))
      }
      if (isRecursiveEvent && isRecursionOn && (startDateTimeChange.current || endDateTimeChange.current)) {
        setIsShowSelectRecursionChangeModePopUp(true)
      } else {
        setIsShowSelectRecursionChangeModePopUp(false)
      }
    },
    [showEditPopUpView],
  )

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetCalendarRangeBeforeNewVisit = (value) => {
    if (value) {
      const fromInUTC = moment(new Date(value?.fromInstance?.d?.d || moment())).utcOffset('+00:00', true)
      const originalOffset = value?.from?.substring(23)
      // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
      const originalDateForRequest = new Date(fromInUTC)
      // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
      const originalDateForView = new Date(fromInUTC.add(1, 'day'))
      originalDateForRequest.setUTCHours(0, 0, 0)
      const newTimeStringForRequest = originalDateForRequest?.toISOString()?.replace('Z', originalOffset)
      const newTimeStringForView = originalDateForView?.toISOString()?.replace('Z', originalOffset)

      const newValue = {
        ...value,
        fromForView: newTimeStringForView,
        from: newTimeStringForRequest,
      }
      dispatch(setCalendarRangeBeforeNewVisit(newValue))
    }
  }

  const setDateRangeQuery = useCallback(
    /** @param {*} value @param {boolean} [isWithReplace] */
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value, isWithReplace = false) => {
      const newFromValue = moment(value).format(DEFAULT_DATE_VALUE_FORMAT)
      // Guard: skip if value hasn't changed to prevent infinite re-render loop.
      // setSearchParams triggers a new searchParams object on every call, which
      // would re-trigger any effect/callback that depends on searchParams.
      if (searchParamsRef.current.get('from') === newFromValue) return

      const params = getValueOfNewSearchParamsByFieldName({
        fieldName: 'from',
        queryValue: newFromValue,
        searchParams: searchParamsRef.current,
      })

      setSearchParamsRef.current(params, {
        replace: isWithReplace,
        state: locationState ?? memberState,
      })
    },
    [locationState, memberState, searchParamsRef, setSearchParamsRef],
  )
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetCalendarOffsetBeforeNewVisit = (value) => {
    setForceShowActiveCalendarDate(false)
    dispatch(setCalendarOffsetBeforeNewVisit(value))
  }

  useEffect(() => {
    const { from } = Object.fromEntries(searchParamsRef.current)
    if (from && isValidDate(from)) {
      const parsedFromDate = moment(from).startOf('week').format(TIME_FOR_DATE_RANGE_REQUEST_FROM)
      const newValue = {
        fromForView: parsedFromDate,
        from: parsedFromDate,
        fromInstance: parsedFromDate,
        to: moment(from).add(6, 'days').format(TIME_FOR_DATE_RANGE_REQUEST_TO),
      }
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(setCalendarRangeBeforeNewVisit(newValue))
    } else {
      const dayOfWeekNumber = moment().day()
      const startOfCurrentWeek =
        dayOfWeekNumber === 6 ? moment().startOf('week') : moment().add(1, 'days').startOf('week')
      setDateRangeQuery(startOfCurrentWeek, true)
    }
  }, [dispatch, setDateRangeQuery])

  const getScheduleByFromToCondition = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (fromValue, to) => {
      if (!fromValue) return

      // Guard: skip if called with the same args to prevent re-render loop.
      // CalendarComponent calls this on render; without the guard, state updates
      // here cause a re-render which re-triggers this callback infinitely.
      const argsKey = `${String(fromValue)}|${String(to)}|${String(state?.providerId)}`
      if (lastScheduleArgsRef.current === argsKey) return
      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
      lastScheduleArgsRef.current = argsKey

      const { from } = Object.fromEntries(searchParamsRef.current)

      const tz = timeZoneFromTheStore ?? customTimeZone
      const fromWithTzAdjustments = moment(fromValue).tz(tz).format('YYYY-MM-DDT00:00:00.000Z')

      const toWithTzAdjustments = moment(to).tz(tz).format('YYYY-MM-DDT00:00:00.000Z')

      const fromForRequest = replaceTimezone(fromValue, fromWithTzAdjustments)
      const toForRequest = replaceTimezone(to, toWithTzAdjustments)

      const fromForQuery = moment(fromValue).add(1, 'days').startOf('week')
      setDateRangeQuery(fromForQuery, true)
      // @ts-expect-error TS2353 -- MIGRATION: not approved, fix when encountered
      setCalendarEndpoints({ fromValue, to })
      if (from || isInitialDateRangeRendering) {
        setIsInitialDateRangeRendering(false)
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        dispatch(getCurrentSchedule(fromForRequest, toForRequest, state?.providerId))
      }
    },
    [
      customTimeZone,
      dispatch,
      isInitialDateRangeRendering,
      searchParamsRef,
      setDateRangeQuery,
      state?.providerId,
      timeZoneFromTheStore,
    ],
  )

  useEffect(() => {
    window.onpopstate = () => {
      const currentMonth = moment().month()
      const { from } = Object.fromEntries(searchParamsRef.current)
      const parsedFromDate = moment(from).startOf('week').format(TIME_FOR_DATE_RANGE_REQUEST_FROM)
      const parsedToDate = moment(from).add(6, 'days').format(TIME_FOR_DATE_RANGE_REQUEST_TO)
      const newValue = {
        fromForView: parsedFromDate,
        from: parsedFromDate,
        fromInstance: parsedFromDate,
        to: moment(from).add(6, 'days').format(TIME_FOR_DATE_RANGE_REQUEST_TO),
      }
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(setCalendarRangeBeforeNewVisit(newValue))
      setForceSetCalendarRangeConfig({
        // @ts-expect-error TS2353 -- MIGRATION: not approved, fix when encountered
        from: parsedFromDate,
        to: moment(from).add(6, 'days').format(TIME_FOR_DATE_RANGE_REQUEST_TO),
      })
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getCurrentSchedule(parsedFromDate, parsedToDate, stateRef.current?.providerId))
      setForceShowActiveCalendarDate(currentMonth === moment(parsedFromDate)?.month())
    }
  }, [dispatch, searchParamsRef, stateRef])

  const getAppointmentInfoById = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (appointmentId) => {
      dispatch(getAppointmentInfo(appointmentId))
      setSelectedAppointment(appointmentId)
    },
    [dispatch],
  )

  const getScheduleInfoHandler = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (scheduleId) => {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getScheduleInfo(scheduleId, state?.providerId))
    },
    [dispatch, state?.providerId],
  )
  const resetScheduleInfoRecurringHandler = useCallback(() => {
    dispatch(resetScheduleInfoRecurring())
  }, [dispatch])

  const clearReducerError = useCallback(() => {
    dispatch(setError())
  }, [dispatch])

  const setReducerError = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (newError, viewType = '') => {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(setError(newError, viewType))
    },
    [dispatch],
  )

  const editScheduleHandler = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (editScheduleBody, eventType) => {
      dispatch(editSchedule(editScheduleBody, eventType || '', state?.providerId))
    },
    [dispatch, state?.providerId],
  )

  const addScheduleHandler = useCallback(
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    ({ TimeZone, Occurrences, Schedules }) => {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(addToSchedule({ TimeZone, Occurrences, Schedules }, state?.providerId))
    },
    [dispatch, state?.providerId],
  )

  const setIsSuccessfullyScheduleEdit = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (newStatus) => {
      dispatch(setIsSuccessScheduleEdit(newStatus))
    },
    [dispatch],
  )

  const setIsAppointmentPopUpInfoVisibleHandler = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (newState) => {
      dispatch(setIsAppointmentPopUpInfoVisible(newState, selectedAppointment))
    },
    [dispatch, selectedAppointment],
  )

  const onDelete = useCallback(() => {
    dispatch(setError())

    setShowCancelSelectedVisit(true)
  }, [dispatch])

  const onCloseCancelVisitPopUp = useCallback(() => {
    setShowCancelSelectedVisit(false)
  }, [])

  const onCancelSelectedVisit = useCallback(
    (reasonId: string, comment?: string) => {
      dispatch(
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        cancelVisit(
          AppointmentInfo[selectedAppointment].VisitId,
          state?.providerId,
          calendarEndpoints,
          reasonId,
          comment,
        ),
      )
    },
    [dispatch, AppointmentInfo, selectedAppointment, state?.providerId, calendarEndpoints],
  )

  const onCancelVisitSuccess = useCallback(() => {
    setShowCancelSelectedVisit(false)
  }, [])

  const onOpenNewVisit = useCallback(
    (useDateTime = true) => {
      let timeZone = ''
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      setCustomTimeZone((zone) => {
        timeZone = zone
        return zone
      })
      setClickedStartDateTime((clickedDateTime) => {
        navigate(state?.newVisitRoute || NEW_VISIT_ROUTE, {
          state: {
            provider: {
              ImageUrl: state.ImageUrl,
              providerId: state.providerId,
              providerName: state.providerName,
            },
            previousState: { ...state, openCalendarDetails: false },
            bookingId: uuidv4(),
            clickedDateTime,
            customTimeZone: timeZone,
            useDateTime,
            search: location.search,
            queryId,
          },
        })
        return clickedDateTime
      })
    },
    [location.search, navigate, state],
  )

  const customHeaderUI = (
    <div
      id='calendarHeaderProviderName'
      className='providerCalendarHeaderTitle'
      onMouseOver={(e) => mouseOverHandler(e, state?.providerName, 'providerName')}
      onFocus={(e) => mouseOverHandler(e, state?.providerName, 'providerName')}
      onMouseLeave={mouseOutHandler}
      onBlur={mouseOutHandler}>
      {state?.providerName}
      <div />
    </div>
  )

  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const breadCrumbsSchema = useMemo(
    () => [
      {
        site: state?.label ?? crumbsLabel ?? AVAILABILITY_LABEL,
        location: `${state?.route || AVAILABILITY_ROUTE}${state?.search || ''}`,
      },
      {
        site: state?.providerName,
        location: '',
      },
    ],
    [state?.providerName],
  )

  // Reset the schedule args guard synchronously (during render, not in useEffect)
  // so CalendarComponent can re-fetch data for the same date range after a mutation.
  // CalendarComponent calls getScheduleByFromToCondition during its render when it
  // sees addToScheduleSuccess/deleteCalendarEventSuccess — a useEffect reset would
  // run too late (after render), causing the guard to block the re-fetch.
  if (addToScheduleSuccess || deleteCalendarEventSuccess) {
    lastScheduleArgsRef.current = null
  }

  useEffect(() => {
    if (deleteCalendarEventSuccess || addToScheduleSuccess) {
      setDeleteEventConfirmationPopUp(null)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setDeleteRecurringEventConfirmationPopUp(null)
      dispatch(setIsDeleteCalendarEventSuccess(false))
      setForceSetCalendarRangeConfig(null)
      setShowDetails(false)
    }
  }, [deleteCalendarEventSuccess, addToScheduleSuccess, dispatch])

  const onDeleteEventFromCalendar = useCallback(() => {
    if (
      moment().isBefore(
        moment(
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          deleteEventConfirmationPopUp?.toDateTime || deleteRecurringEventConfirmationPopUp?.detailsInfo.toDateTime,
        )
          .parseZone()
          .tz(customTimeZone, true),
      )
    ) {
      dispatch(
        deleteEvent(
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [deleteEventConfirmationPopUp?.itemId || deleteRecurringEventConfirmationPopUp?.detailsInfo?.id],
          state?.providerId,
          customTimeZone,
          true,
        ),
      )
    } else {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(setError(errorCodes.CANNOT_ALTER_SCHEDULE))
    }
  }, [
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    deleteEventConfirmationPopUp?.toDateTime,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    deleteEventConfirmationPopUp?.itemId,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    deleteRecurringEventConfirmationPopUp?.detailsInfo?.toDateTime,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    deleteRecurringEventConfirmationPopUp?.detailsInfo?.id,
    customTimeZone,
    dispatch,
    state?.providerId,
  ])
  const onDeleteRecurringEventFromCalendar = useCallback(() => {
    if (
      deleteRecurringEventConfirmationPopUp &&
      moment().isBefore(
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        moment(deleteRecurringEventConfirmationPopUp?.detailsInfo.toDateTime).parseZone().tz(customTimeZone, true),
      )
    ) {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const toDateTime = moment(deleteRecurringEventConfirmationPopUp?.detailsInfo.toDateTime)
        .parseZone()
        .tz(customTimeZone, true)
        .format(DATE_TIME_ISO_FORMAT)
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const fromDateTime = moment(deleteRecurringEventConfirmationPopUp?.detailsInfo.fromDateTime)
        .parseZone()
        .tz(customTimeZone, true)
        .format(DATE_TIME_ISO_FORMAT)
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const { scheduleId, scheduleOrder } = deleteRecurringEventConfirmationPopUp.detailsInfo
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const { RecurringType, Frequency, WeekDays } = deleteRecurringEventConfirmationPopUp.scheduleInfoRecurring
      if (moment(fromDateTime).isSame(moment(scheduleInfoFrom)) || scheduleOrder === 0) {
        dispatch(
          deleteEvent(
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            [deleteRecurringEventConfirmationPopUp?.detailsInfo?.scheduleId],
            state?.providerId,
            customTimeZone,
            false,
          ),
        )
        return
      }

      const schedule = buildEditRecurringSchedulePayload({
        timeZone: recurringBaseTimeZone,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        visitTypeGroupId: detailsInfo.visitTypeGroupId,
        scheduleId,
        fromDateTime: scheduleInfoFrom,
        toDateTime: scheduleInfoTo,
        recurringType: RecurringType,
        frequency: Frequency,
        weekDays: WeekDays,
        occurrenceEndDateTime: toDateTime,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        occurrenceId: deleteRecurringEventConfirmationPopUp.detailsInfo.id,
      })
      dispatch(editSchedule(schedule, 'schedule', state?.providerId))
    } else {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(setError(errorCodes.CANNOT_ALTER_SCHEDULE))
    }
  }, [
    customTimeZone,
    deleteRecurringEventConfirmationPopUp,
    dispatch,
    recurringBaseTimeZone,
    scheduleInfoFrom,
    scheduleInfoTo,
    state?.providerId,
    showEditPopUpView,
    detailsInfo,
  ])

  const setCalendarCustomTimeZone = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      if (parsedTimeZone) {
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        setParsedTimeZone(parseTimezone(value)?.label)
      }
      dispatch(setInitialTimeZone(value))
      setCustomTimeZone(value)
    },
    [dispatch, parseTimezone, parsedTimeZone],
  )
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  function popUpWrapper(view) {
    if (useAdminWrapper) {
      return view
    } else {
      return <Portal>{view}</Portal>
    }
  }

  // Shared calendar content that can be wrapped or used standalone
  const calendarContent = (
    <div className='calendarPageBodyContainer'>
      <CalendarPageListener
        providerId={state?.providerId}
        fromQuery={from}
        onCancelVisitSuccess={() => {
          onCancelVisitSuccess()
        }}
      />
      {appointmentNameToolTipInfo ?
        <FullTextPositionToolTip
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          toolTipContainerPositionStyle={appointmentNameToolTipInfo}
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          title={appointmentNameToolTipInfo.title}
        />
      : null}
      {isSelectModePopUp ?
        popUpWrapper(
          <SelectModePopUp
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            isRecurrenceOn
            clickedStartDateTime={clickedStartDateTime}
            clickedEndDateTime={clickedEndDateTime}
            editScheduleHandler={editScheduleHandler}
            // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
            startOccurrenceDate={showEditPopUpView.OccurrenceStartTime}
            // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
            endOccurrenceDate={showEditPopUpView.OccurrenceEndTime}
            // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
            repeatEndDate={showEditPopUpView.EndDateTime}
            // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
            occurrenceId={showEditPopUpView.itemId}
            setIsSelectModePopUp={setIsSelectModePopUp}
            // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
            scheduleId={showEditPopUpView.scheduleId}
            // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
            viewType={showEditPopUpView.type}
            // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
            recurrenceEndDateTime={showEditPopUpView.EndDateTime}
            // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
            occurrenceOrder={showEditPopUpView.scheduleOrder}
            availableStatesCodesArray={availableStatesCodesArray}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            initialAvailableStateCodes={detailsInfo.availableStatesCodes}
            providerAvailableStates={providerAvailableStates}
            daysOfWeekRef={daysOfWeekRef}
            // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
            visitTypeGroupId={showEditPopUpView.visitTypeGroupId}
          />,
        )
      : null}
      {showAvailabilityView ?
        popUpWrapper(
          <AvailabilityPopUp
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            calendarTimeZone={customTimeZone ?? currentTimeZone}
            editScheduleHandler={editScheduleHandler}
            addScheduleHandler={addScheduleHandler}
            setReducerError={setReducerError}
            setIsSuccessfullyScheduleEdit={setIsSuccessfullyScheduleEdit}
            startDate={clickedStartDateTime}
            endDate={clickedEndDateTime}
            isRecurrenceOn={isRecurrenceOn}
            toggleIsRecurrenceOn={toggleIsRecurrenceOn}
            closePopUpCallback={setShowAvailabilityView}
            clickedStartDateTime={clickedStartDateTime}
            clickedEndDateTime={clickedEndDateTime}
            setClickedStartDateTime={setClickedStartDateTime}
            setClickedEndDateTime={setClickedEndDateTime}
            viewType='availability'
            daysOfWeekRef={daysOfWeekRef}
            scheduleInfoFrom={scheduleInfoFrom}
            scheduleInfoTo={scheduleInfoTo}
            addToScheduleSuccess={addToScheduleSuccess}
            editScheduleSuccess={editScheduleSuccess}
            providerAvailableStates={providerAvailableStates}
            availableStatesCodesArray={availableStatesCodesArray}
            setAvailableStatesCodesArray={setAvailableStatesCodesArray}
            visitTypeGroups={localVisitTypeGroups}
            providerId={state?.providerId ?? queryId}
          />,
        )
      : null}
      {showEditPopUpView ?
        popUpWrapper(
          <AvailabilityPopUp
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            calendarTimeZone={customTimeZone ?? currentTimeZone}
            editScheduleHandler={editScheduleHandler}
            addScheduleHandler={addScheduleHandler}
            setReducerError={setReducerError}
            setIsSuccessfullyScheduleEdit={setIsSuccessfullyScheduleEdit}
            startDate={clickedStartDateTime}
            endDate={clickedEndDateTime}
            daysOfWeekRef={daysOfWeekRef}
            closePopUpCallback={setShowEditPopUpView}
            isRecurrenceOn={isRecurrenceOn}
            toggleIsRecurrenceOn={toggleIsRecurrenceOn}
            clickedStartDateTime={clickedStartDateTime}
            clickedEndDateTime={clickedEndDateTime}
            setClickedStartDateTime={setClickedStartDateTime}
            setIsSelectModePopUp={setIsSelectModePopUp}
            isShowSelectRecursionChangeModePopUp={isShowSelectRecursionChangeModePopUp}
            setStartDateHandler={setStartDateHandler}
            setClickedEndDateTime={setClickedEndDateTime}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            viewType={showEditPopUpView.type.includes('availability') ? 'availability' : showEditPopUpView.type}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            isRecursive={showEditPopUpView.isRecursive}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            recurrenceEndDateTime={showEditPopUpView.EndDateTime}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            recurrenceFrequency={showEditPopUpView.Frequency}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            occurrenceId={showEditPopUpView.itemId}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            repeatDays={showEditPopUpView.RepeatDays}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            scheduleId={showEditPopUpView.scheduleId}
            isEditMode
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            scheduleOrder={showEditPopUpView.scheduleOrder}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            occurrenceOrder={showEditPopUpView.scheduleOrder}
            scheduleInfoFrom={scheduleInfoFrom}
            scheduleInfoTo={scheduleInfoTo}
            addToScheduleSuccess={addToScheduleSuccess}
            editScheduleSuccess={editScheduleSuccess}
            providerAvailableStates={providerAvailableStates}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            isOverridden={detailsInfo.IsOverridden}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            isAppliedForAllLicensedStates={detailsInfo.IsAppliedForAllLicensedStates}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            overriddenStatesCodes={detailsInfo.availableStatesCodes}
            setIsShowSelectRecursionChangeModePopUp={setIsShowSelectRecursionChangeModePopUp}
            availableStatesCodesArray={availableStatesCodesArray}
            setAvailableStatesCodesArray={setAvailableStatesCodesArray}
            visitTypeGroups={localVisitTypeGroups}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            visitTypeGroupId={showEditPopUpView.visitTypeGroupId}
            setShowEditPopUpView={setShowEditPopUpView}
            providerId={state?.providerId ?? queryId}
          />,
        )
      : null}
      {showPNBView ?
        popUpWrapper(
          <AvailabilityPopUp
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            calendarTimeZone={customTimeZone ?? currentTimeZone}
            editScheduleHandler={editScheduleHandler}
            addScheduleHandler={addScheduleHandler}
            setReducerError={setReducerError}
            setIsSuccessfullyScheduleEdit={setIsSuccessfullyScheduleEdit}
            startDate={clickedStartDateTime}
            endDate={clickedEndDateTime}
            daysOfWeekRef={daysOfWeekRef}
            isRecurrenceOn={isRecurrenceOn}
            toggleIsRecurrenceOn={toggleIsRecurrenceOn}
            closePopUpCallback={setShowPNBView}
            clickedStartDateTime={clickedStartDateTime}
            clickedEndDateTime={clickedEndDateTime}
            setClickedStartDateTime={setClickedStartDateTime}
            setClickedEndDateTime={setClickedEndDateTime}
            viewType='PNB'
            scheduleInfoFrom={scheduleInfoFrom}
            scheduleInfoTo={scheduleInfoTo}
            addToScheduleSuccess={addToScheduleSuccess}
            editScheduleSuccess={editScheduleSuccess}
            providerAvailableStates={providerAvailableStates}
            availableStatesCodesArray={availableStatesCodesArray}
            setAvailableStatesCodesArray={setAvailableStatesCodesArray}
            visitTypeGroups={localVisitTypeGroups}
            providerId={state?.providerId ?? queryId}
          />,
        )
      : null}
      {showDetails ?
        popUpWrapper(
          <DetailsView
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            resetScheduleInfoRecurringHandler={resetScheduleInfoRecurringHandler}
            customTimeZone={customTimeZone ?? currentTimeZone}
            getScheduleInfoHandler={getScheduleInfoHandler}
            detailsInfo={detailsInfo}
            setShowDetails={setShowDetails}
            setClickedStartDateTime={setClickedStartDateTime}
            setClickedEndDateTime={setClickedEndDateTime}
            setShowEditAvailabilityView={setShowEditPopUpView}
            onSetDeleteEventConfirmationPopUp={setDeleteEventConfirmationPopUp}
            onSetDeleteRecurringEventConfirmationPopUp={setDeleteRecurringEventConfirmationPopUp}
            visitTypeGroups={localVisitTypeGroups}
          />,
        )
      : null}
      {isAppointmentPopUpInfoVisible[selectedAppointment] && AppointmentInfo[selectedAppointment] ?
        popUpWrapper(
          <DetailsView
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            isAdminApp
            customTimeZone={customTimeZone ?? currentTimeZone}
            resetScheduleInfoRecurringHandler={resetScheduleInfoRecurringHandler}
            getScheduleInfoHandler={getScheduleInfoHandler}
            detailsInfo={AppointmentInfo[selectedAppointment]}
            setShowDetails={setIsAppointmentPopUpInfoVisibleHandler}
            ViewType='appointment'
            onDelete={onDelete}
            visitTypeGroups={localVisitTypeGroups}
          />,
        )
      : null}
      {state ?
        <CalendarComponent
          isWithTimeZoneSelect
          TimeZoneSelectComponent={TimeZoneSelect}
          setCustomTimeZone={setCalendarCustomTimeZone}
          customTimeZone={customTimeZone ?? currentTimeZone}
          setShowPNBView={setShowPNBView}
          customHeaderTitleUI={customHeaderUI}
          setShowAvailabilityView={setShowAvailabilityView}
          visitsSchedule={localVisitsSchedule}
          schedule={localSchedule}
          pnbSchedule={localPnbSchedule}
          loading={loading}
          setClickedStartDateTime={setClickedStartDateTime}
          setClickedEndDateTime={setClickedEndDateTime}
          getScheduleByFromToCondition={getScheduleByFromToCondition}
          addToScheduleSuccess={addToScheduleSuccess}
          deleteCalendarEventSuccess={deleteCalendarEventSuccess}
          toggleIsRecurrenceOn={toggleIsRecurrenceOn}
          setDetailsInfo={setDetailsInfo}
          setShowDetails={setShowDetails}
          getAppointmentInfoById={getAppointmentInfoById}
          error={error}
          clearReducerError={clearReducerError}
          viewType='week'
          openNewVisit={onOpenNewVisit}
          onSetCalendarRangeBeforeNewVisit={onSetCalendarRangeBeforeNewVisit}
          calendarRangeBeforeNewVisit={calendarRangeBeforeNewVisit}
          calendarOffsetBeforeNewVisit={calendarOffsetBeforeNewVisit}
          onSetCalendarOffsetBeforeNewVisit={onSetCalendarOffsetBeforeNewVisit}
          parsedTimeZone={parsedTimeZone}
          forceShowActiveCalendarDate={forceShowActiveCalendarDate}
          forceSetCalendarRangeConfig={forceSetCalendarRangeConfig}
          isAdmin
          isSubView={!useAdminWrapper}
        />
      : null}
    </div>
  )

  // Shared popups and modals
  const popupsAndModals = (
    <>
      {deleteEventConfirmationPopUp ?
        popUpWrapper(
          <ConfirmationPopup
            title={CALENDAR_PAGE_DELETE_EVENT_CONFIRMATION_POP_UP_TITLE}
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            additionalContainerClass='admin-calendar-availability-delete-pop-up-container'
            id='admin-availability-calendar-delete-pop-up'
            primaryBtnAction={onDeleteEventFromCalendar}
            primaryBtnText={CALENDAR_PAGE_DELETE_EVENT_CONFIRMATION_POP_UP_PRIMARY_BUTTON_TEXT}
            secondaryBtnText={CALENDAR_PAGE_DELETE_EVENT_CONFIRMATION_POP_UP_SECONDARY_BUTTON_TEXT}
            msg={CALENDAR_PAGE_DELETE_EVENT_CONFIRMATION_POP_UP_BODY_TEXT}
            secondaryBtnAction={onCloseDeleteEventConfirmationPopUp}
            closeAction={onCloseDeleteEventConfirmationPopUp}
          />,
        )
      : null}

      {deleteRecurringEventConfirmationPopUp ?
        popUpWrapper(
          <ConfirmationPopup
            title={CALENDAR_PAGE_DELETE_EVENT_CONFIRMATION_POP_UP_TITLE}
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            additionalContainerClass='admin-calendar-availability-delete-pop-up-container'
            id='admin-availability-calendar-delete-pop-up'
            primaryBtnAction={onDeleteRecurringEventFromCalendar}
            primaryBtnText={text.RECURRENCE_DELETION_PRIMARY_BUTTON}
            secondaryBtnText={text.RECURRENCE_DELETION_SECONDARY_BUTTON}
            msg={text.RECURRENCE_DELETION_CONFIRM_MESSAGE}
            secondaryBtnAction={onDeleteEventFromCalendar}
            closeAction={onCloseDeleteRecurringEventConfirmationPopUp}
            buttonWidth={330}
            extraView={
              <ScheduleDetailView
                // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                isPopUp
                extraStyle={styles.RECURRENCE_SCHEDULE_STYLE}
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                detailsInfo={deleteRecurringEventConfirmationPopUp.detailsInfo}
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                customTimeZone={deleteRecurringEventConfirmationPopUp.customTimeZone}
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                scheduleInfoRecurring={deleteRecurringEventConfirmationPopUp.scheduleInfoRecurring}
              />
            }
          />,
        )
      : null}
      {showCancelSelectedVisit ?
        popUpWrapper(
          <CancelVisitPopup
            closeAction={onCloseCancelVisitPopUp}
            cancelAction={onCancelSelectedVisit}
            isReviewed={isAsynchronousVisitMethod(AppointmentInfo[selectedAppointment]?.Method)}
          />,
        )
      : null}
    </>
  )

  const showLoadingOverlay = useAdminWrapper && (loading || memberLoading)

  return (
    <div className='w-full'>
      {showLoadingOverlay ?
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-white/80'>
          <PageLoadingSpinner />
        </div>
      : null}
      <div style={{ visibility: showLoadingOverlay ? 'hidden' : 'visible' }}>{calendarContent}</div>
      {popupsAndModals}
    </div>
  )
})

export default CalendarPage
